import { useEffect, useContext, useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Correct import
import sessionTimeout from "../../assests/Sessionout.gif";

const TIMEOUT_DURATION = 15* 60 * 1000; // 15 minutes in milliseconds

export const useAutoLogout = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();  

    const timeoutId = useRef();
    const isWarningShown = useRef(false);

    // Prevent early return by handling the missing logout function safely
    if (!logout) {
        console.error("AuthContext is not available. Ensure AuthProvider wraps your components.");
    }

    // const performLogout = useCallback(() => {
    //      sessionStorage.removeItem("selectedTheme");
    //     sessionStorage.clear();
    //     if (logout) logout(); // Ensure logout exists before calling it
    //     navigate('/');
    // }, [logout, navigate]);

    const performLogout = useCallback(() => {
  sessionStorage.clear(); // This will also clear the theme preference
  if (logout) logout();
  
  // Reset theme to default
  const themes = ["template1", "template2","template3","template4","template5"];
  document.body.classList.remove(...themes.map((t) => `theme-${t}`));
  document.body.classList.add("theme-template2");
  
  navigate('/');
}, [logout, navigate]);

    const showWarning = useCallback(() => {
        if (isWarningShown.current) return;
        isWarningShown.current = true;

        const overlayDiv = document.createElement('div');
        overlayDiv.classList.add('session-overlay');
        overlayDiv.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            backdrop-filter: blur(5.5px) !important;
            align-items: center;
            z-index: 9998;
            background: rgba(53, 66, 88, 0.84);
        `;
        document.body.appendChild(overlayDiv);

        const alertDiv = document.createElement('div');
        alertDiv.style.cssText = `
            text-align: center;
            color: #fff;
            font-size: px;
            padding: 20px;
        `;
        overlayDiv.appendChild(alertDiv);

        // alertDiv.innerHTML = `<p>Session timeout warning. Please wait...</p>`;

        setTimeout(() => {
            alertDiv.innerHTML = `
                <img src="${sessionTimeout}" alt="Timeout Warning" style="width: 15vw; height: auto; margin-bottom: 15px;" />
                <h3 style="margin-bottom: 15px; color:white">Session Timeout</h3>
                <p style="margin-bottom: 20px; color:#AAB1B">
                    Oops! Your session took a little nap due to inactivity.
                </p>
                <button style="background-color: transparent; border: 1px solid #FFFFFF; border-radius: 10px; padding: 4px 16px;  color:rgb(255, 255, 255); cursor: pointer; width: 100px;">OK</button>
            `;

            const okButton = alertDiv.querySelector('button');
            okButton.addEventListener('click', () => {
                alertDiv.remove();
                overlayDiv.remove();
                performLogout();
            });
        });
    }, [performLogout]);

    const resetTimer = useCallback(() => {
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }
        isWarningShown.current = false;
        timeoutId.current = setTimeout(showWarning, TIMEOUT_DURATION);
    }, [showWarning]);

    useEffect(() => {
        if (!logout) return; // Prevent execution if logout is unavailable

        const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

        const handleUserActivity = () => {
            if (!isWarningShown.current) {
                resetTimer();
            }
        };

        events.forEach(event => {
            window.addEventListener(event, handleUserActivity);
        });

        resetTimer(); // Initial timer setup

        return () => {
            events.forEach(event => {
                window.removeEventListener(event, handleUserActivity);
            });
            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
            }
        };
    }, [resetTimer, logout]); // Include logout in dependency array

    return resetTimer;
};